import React from "react";
import Link from "gatsby-link";
import Imgix from "react-imgix";
import Shadow from "../Shadow";
import { endSlash } from "../../util/helperFunctions";


// Page Query with banner photo background ex: Riverfront Canal Crusises
const PageQueryBannerPhoto = ({ page }) => {
  return (
    <div className="page-query-banner bg-stone ph2 pt2 pt3-l flex justify-center">
      <Link
        to={endSlash(page.route)}
        className="page-query-banner__banner db bg-grey2 relative flex flex-column justify-center w-100 mw-1060"
      >
        {page.bannerImage && (
          <div className="absolute top-0 left-0 h-100 w-100">
            <Imgix
              src={page.bannerImage.url}
              className="bg-center image-cover mb0 h-100 w-100"
              imgixParams={{
                "max-w": 2732,
                "fp-x": page.bannerImageFocalPointX,
                "fp-y": page.bannerImageFocalPointY,
                auto: ["compress"],
                fit: "crop",
                crop: "focalpoint"
              }}
              htmlAttributes={{
                alt: page.bannerImageAltText
              }}
            />
            <Shadow />
          </div>
        )}
        <h2 className="white h-2--small h-2--l mb0 ph1 tc relative z-1">
          {page.title}
        </h2>
        <p className="h-6 white ttu mb0 mt1 tc relative z-1">Learn More</p>
      </Link>
    </div>
  );
};

export default PageQueryBannerPhoto;



// WEBPACK FOOTER //
// ./src/components/PageHelpers/PageQueryBannerPhoto.js